//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'UserRenderer',
  props: {
    user: {
      type: Object,
      default: undefined
    },
    avatarOnly: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'span'
    },
    appearance: {
      type: String,
      default: undefined
    },
    alt: {
      type: String,
      default: undefined
    },
    link: {
      type: String,
      default: '#'
    }
  },
  methods: {
    onClick(e) {
      if (this.tag === 'a') {
        e.stopPropagation();
      }
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/UserRenderer.vue_rollup-plugin-vue=script.js